import datacentral from '@/utils/axios/datacentral'
import { ResponseObject } from '@/types/shared'
import {
    CreatePricingStepPayload,
    ProductPricingStep,
    UpdatePricingStepPayload,
} from '../types/product'

const getBaseUrl = (productId: number, optionId: number) =>
    `/products/${productId}/config-options/${optionId}/pricing-steps`

export const createPricingStep = async (
    productId: number,
    optionId: number,
    payload: CreatePricingStepPayload
): Promise<ProductPricingStep> => {
    const response = await datacentral.post<ResponseObject<ProductPricingStep>>(
        getBaseUrl(productId, optionId),
        payload
    )
    return response.data.result
}

export const updatePricingStep = async (
    productId: number,
    optionId: number,
    stepId: number,
    payload: UpdatePricingStepPayload
): Promise<ProductPricingStep> => {
    const response = await datacentral.put<ResponseObject<ProductPricingStep>>(
        `${getBaseUrl(productId, optionId)}/${stepId}`,
        payload
    )
    return response.data.result
}

export const deletePricingStep = async (
    productId: number,
    optionId: number,
    stepId: number
): Promise<void> => {
    await datacentral.delete(`${getBaseUrl(productId, optionId)}/${stepId}`)
}
